import { useQuery } from '@tanstack/react-query';
import { getOrganizationDashboardUsageHistory } from '@kirin/api-client/api/organizations';

import { apiClient } from '@/lib/api-client';
import { queryKeys } from './queryKeys';
import { cacheConfigForCollaborativeData } from './queryConfig';
import { retryHandlers } from './helpers';

/**
 * Hook to fetch organization dashboard usage history (active users over time).
 *
 * Mirrors useOrganizationDashboardAlerts but targets the /dashboard/usage endpoint.
 */
export function useOrganizationDashboardUsage(
  organizationId: string | undefined,
  from: string,
  to: string,
  enabled: boolean = true,
  tz?: string
) {
  const isEnabled =
    enabled &&
    !!organizationId &&
    typeof from === 'string' &&
    typeof to === 'string';

  return useQuery({
    queryKey: queryKeys.organizations.dashboardUsage(organizationId ?? '', {
      from,
      to,
      tz,
    }),
    queryFn: () => {
      if (!organizationId) {
        throw new Error('organizationId is required');
      }
      return getOrganizationDashboardUsageHistory(apiClient, organizationId, {
        from,
        to,
        tz,
      });
    },
    enabled: isEnabled,
    ...cacheConfigForCollaborativeData,
    retry: retryHandlers.list,
  });
}
